
(function () {
  'use strict';

  // common finish map
  var FINISH_HEX = {
    // chromes / silvers
    'chrome':                 '#c8c8c8',
    'polished-chrome':        '#cfcfcf',
    'brushed-chrome':         '#a8a8a8',
    'satin-chrome':           '#b5b5b5',
    'silver':                 '#c0c0c0',

    // brasses / golds
    'brass':                  '#b5a642',
    'polished-brass':         '#d4af37',
    'antique-brass':          '#9c7a3c',
    'brushed-brass':          '#b5a76a',
    'satin-brass':            '#b5a76a',
    'aged-brass':             '#8b6f3c',
    'gold':                   '#d4af37',
    'polished-gold':          '#e6c200',
    'matte-gold':             '#b58e1a',
    'rose-gold':              '#b76e79',
    'gold-rose':              '#b76e79',

    // nickels
    'nickel':                 '#a8a8a8',
    'polished-nickel':        '#bcbcbc',
    'brushed-nickel':         '#9a9a9a',
    'satin-nickel':           '#a8a8a8',

    // coppers
    'copper':                 '#b87333',
    'polished-copper':        '#d68740',
    'antique-copper':         '#8b5a2b',
    'brushed-copper':         '#a06642',

    // bronzes
    'bronze':                 '#cd7f32',
    'antique-bronze':         '#a87332',
    'oil-rubbed-bronze':      '#3a2818',
    'dark-bronze':            '#2e2018',

    // blacks / whites / neutrals
    'black':                  '#1a1a1a',
    'matte-black':            '#1a1a1a',
    'satin-black':            '#262626',
    'gloss-black':            '#0d0d0d',
    'white':                  '#f5f5f5',
    'matte-white':            '#f5f5f5',
    'gloss-white':            '#ffffff',
    'off-white':              '#efece5',
    'cream':                  '#f5f0e1',
    'pewter':                 '#8a8a8a',
    'gunmetal':               '#2a3439',
    'graphite':               '#383838',
    'charcoal':               '#36454f',

    // clear / smoke / glass
    'clear':                  '#eef2f5',
    'frosted':                '#e8e8e8',
    'smoke':                  '#3a3a3a',
    'smoked':                 '#3a3a3a',
    'amber':                  '#ffbf00',

    // wood-tones (linear chandeliers etc.)
    'walnut':                 '#5d4037',
    'oak':                    '#c19a6b',
    'mahogany':               '#4e2728',
    'natural':                '#d2b48c',

    'satin-graphite':         '#333333',
    'matte-graphite':         '#333333',
    'brushed-graphite':       '#3a3a3a',
    'aged-graphite':          '#2f2f2f',
    'dark-graphite':          '#2a2a2a',
    'satin-copper':           '#a56a43',
    'aged-copper':            '#7a4a2b',
    'satin-black':            '#262626',
    'textured-black':         '#1f1f1f',

    'champagne':              '#e6d5a8',
    'champagne-gold':         '#d9c37a',
    'brushed-gold':           '#cbb26b',
    'aged-gold':              '#c0a250',
    'antique-gold':           '#c5a253',
    'burnished-brass':        '#a8894a',
    'weathered-brass':        '#9c8748',
    'matte-brass':            '#a08a3c',
    'heritage-brass':         '#9a7d3f'
  };

  function handleize(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // quick css color check
  var colorTester = null;
  function isValidCssColor(str) {
    if (!str) return false;
    if (!colorTester) colorTester = document.createElement('div');
    colorTester.style.color = '';
    colorTester.style.color = str;
    return colorTester.style.color !== '';
  }

  function hasRealBackgroundImage(el) {
    var s = el.getAttribute('style') || '';
    var m = s.match(/background-image\s*:\s*url\(\s*['"]?\s*([^'")\s]+)/i);
    return !!(m && m[1] && m[1].toLowerCase() !== 'none');
  }

  // placeholders indicate unconfigured swatches
  var BLANK_BG = { '': 1, 'white': 1, '#fff': 1, '#ffffff': 1, 'transparent': 1, 'inherit': 1, 'initial': 1, 'rgb(255,255,255)': 1, 'rgba(0,0,0,0)': 1 };
  function hasRealBackgroundColor(el) {
    var s = el.getAttribute('style') || '';
    var m = s.match(/background-color\s*:\s*([^;]+)/i);
    if (!m) return false;
    var val = m[1].trim();
    if (BLANK_BG[val.toLowerCase().replace(/\s+/g, '')]) return false;
    return isValidCssColor(val);
  }

  function pickColor(value) {
    var handle = handleize(value);
    if (!handle) return null;

    // 1 map
    if (FINISH_HEX[handle]) return FINISH_HEX[handle];

    // 2 css color by handle
    if (isValidCssColor(handle)) return handle;

    // 3 css color by raw value
    if (isValidCssColor(value)) return value;

    return null;
  }

  function applyColor(el, color) {
    // force override app inline style
    el.style.setProperty('background-color', color, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.setAttribute('data-hulk-fallback', 'color');
  }

  function applyTextFallback(el, value) {
    if (el.querySelector('.hulk-swatch-fallback-text')) return;
    var span = document.createElement('span');
    span.className = 'hulk-swatch-fallback-text';
    span.textContent = value;
    el.appendChild(span);
    el.setAttribute('data-hulk-fallback', 'text');
  }

  function patch(el) {
    if (el.__hulkPatched) return;
    el.__hulkPatched = true;

    // preserve configured swatches
    if (hasRealBackgroundImage(el)) return;
    if (hasRealBackgroundColor(el)) return;

    var value = el.getAttribute('data-conditional-value') || el.getAttribute('value') || '';
    if (!value) return;

    var color = pickColor(value);
    if (color) {
      applyColor(el, color);
      return;
    }

    applyTextFallback(el, value);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var swatches = scope.querySelectorAll('.hulkapps_swatch_option .hulkapps_option_child');
    for (var i = 0; i < swatches.length; i++) patch(swatches[i]);
  }

  // tiny inline css for text fallback
  function injectStyles() {
    if (document.getElementById('hulk-swatch-fallback-styles')) return;
    var css = [
      '.hulkapps_swatch_option .hulkapps_option_child[data-hulk-fallback="text"] {',
      '  display: flex !important;',
      '  align-items: center;',
      '  justify-content: center;',
      '  background: #f4f4f4 !important;',
      '  text-align: center;',
      '  overflow: hidden;',
      '}',
      '.hulkapps_swatch_option .hulk-swatch-fallback-text {',
      '  font-family: "Poppins", sans-serif;',
      '  font-size: 9px;',
      '  line-height: 1;',
      '  color: #333;',
      '  padding: 2px;',
      '  word-break: break-word;',
      '  pointer-events: none;',
      '}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'hulk-swatch-fallback-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function start() {
    injectStyles();
    scan(document);

    // app injects swatches late so observe dom too
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('hulkapps_option_child')) {
              if (n.closest('.hulkapps_swatch_option')) patch(n);
            } else if (n.querySelectorAll) {
              scan(n);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
